import React from 'react';
import OtpInput from 'react-otp-input';

const CodeInput = ({ onChange = () => {}, code = ''}) => {
	const handleChange = (e) => onChange && onChange(e);
	return (
		<div className="sf-code-input">
			<div className="input-wrap">
				<OtpInput
					value={code}
					placeholder={'______'}
					onChange={handleChange}
					numInputs={6}
					shouldAutoFocus
					isInputNum
				/>
			</div>
		</div>
	)
}

export default CodeInput;